import {Ingredient} from "./ingredient";
import {ProductMeta, ProductSize} from "./product_meta";
import {Menu} from "./menu";
import {PricePipe} from "../pipes/getPrice";
import {ProductRule} from "./product_rule";

export class ProductSpecial {
  /**
   * Reference to the parent category
   */
  public searchMask = "";
  public category: Menu;
  public id: number;
  public rules : any;
  public price : any;
  public entries : any;
  public menuOptions: any;

  getCategory() {
    return this.category;
  }

  getPayload() {
    return this.payload;
  }

  serialize() {
    return {
      id: this.id,
      initialPayload: this.getPayload(),
      addedIngredients: this.addedIngredients.map(i => i.id),
      removedIngredients: this.removedIngredients.map(i => i.id),
      ingredients: this.ingredients,
      price: this.getCartPrice(),
      category: this.getCategory(),
      image: this.image,
      description: this.description,
      name: this.name,
      number: this.number,
      quantity: this.quantity,
      size: this.meta.getSize(),
      disable_ingredient_change: this.disable_ingredient_change,
      message: this.message,
      menuOptions: this.menuOptions,
      type: this.type,
    };
  }

  getCartPrice() {
    let menuPriceSet = this.prices[0];
    const {price, name} = menuPriceSet;

    let basePrice = price;

    this.rules.forEach((rule) => {
      if (this.entries[rule.id]) {
        const selectedProduct = rule.products.find(p => p.id === this.entries[rule.id]);
        if (selectedProduct) {
          if (selectedProduct.menuPrices) {
            const selectedMenuPrice = selectedProduct.menuPrices.find(p => p.name === name);
            if (selectedMenuPrice) {
              if (selectedMenuPrice.addPrice) {
                basePrice += parseFloat(selectedMenuPrice.price);
              }
            }
          }
        }
      }
    });

    return basePrice * this.quantity;
  }

  static deserialize(payload, category) {

  }

  public ingredientsChanged = false;

  /**
   * Descriptions
   */
  public description: string;

  /**
   * The "id" of the product in the menu card, people may search for this value
   * It's a string because some restaurants uses prefixes.
   */
  public number: string;

  /**
   * Name of the product
   */
  public name: string;

  /**
   * image URL
   */
  public image: any;

  /**
   * current product ingredients (these can be updated in the app)
   */
  public ingredients: Ingredient[];

  /**
   * A list of possible prices (and also sizes)
   */
  public prices: ProductMeta[];

  /**
   * A collection of different variations. This is used for things like dressing and other variations
   */
  public variations: ProductVariation[];

  /**
   * Whether or not user can make changes to the products ingredients
   */
  public disable_ingredient_change;

  /**
   * internal cart id for later removal or edit
   */
  public identifier: number | string;

  public message;

  /**
   * Holds the current product pricedasd
   */
  public meta: ProductMeta;

  public quantity: number = 1;

  public setSize(size: ProductSize) {
    this.meta.setSize(size);
  }

  public setMeta(meta: ProductMeta, index) {
    this.meta = meta;
    this.meta.sizeIndex = index;
    this.meta.priceSet = JSON.parse(JSON.stringify(this.prices));
  }

  /**
   * Holds a copy of the products ingredients to view changes lateron.
   */
  public defaultIngredients: any;
  private payload: ProductPayload;

  public type;
  constructor(payload: ProductPayload, category: Menu) {
    /**
     * for later retrival
     * @type {ProductPayload}
     */
    this.id = payload.id;
    this.payload = payload;
    this.category = category;
    this.image = payload.image;
    this.description = payload.description;
    this.number = payload.number || "";
    this.name = payload.name;
    this.type = payload.type;
    this.price = payload.price;

    if (payload.ingredients) {
      this.ingredients = Object.keys(payload.ingredients).map((id) => {
        return new Ingredient(payload.ingredients[id]);
      });
    }

    this.prices = payload.prices.map((payload) => {
      return new ProductMeta(payload);
    });


    this.meta = this.prices[0];
    if (this.prices.length > 2) { // klein,groß,familie
      this.meta = this.prices[1]; // groß
    }

    this.disable_ingredient_change = payload.disable_ingredient_change;
    this.message = payload.message;

    this.rules = payload.rules.map(rule => new ProductRule(rule));
  }

  public removedIngredients: Ingredient[] = [];
  public addedIngredients: Ingredient[] = [];

  hasChangedIngredients() {
    return (this.addedIngredients.length || this.removedIngredients.length);
  }

  setIdentifier() {
    const timeStamp = +new Date();
    this.identifier = `${timeStamp}-${this.name}-${Math.random()}`;
  }

  canChangeSize() {
    return this.prices.length > 0;
  }

  /**
   * Changes product based on given variation
   * This is used for crucial changes to the product like dressing or beverage type.
   * Using variations you can also change the product price.
   * @param variation
   */
  setVariation(variation: ProductVariation) {
    this.name = `${this.name} (${variation.title})`;
    this.description = variation.description;
    if (variation.meta) {
      this.meta = variation.meta;
    }
  }
}


export class ProductVariation {
  public title: string;
  public description: string;
  public meta?: ProductMeta;

  constructor(payload) {
    this.title = payload.title;
    this.description = payload.description;
    if (payload.price)
      this.meta = new ProductMeta(payload.price);
  }
}

export interface ProductPayload {
  id: number;
  description: string;
  number: string;
  message: string;
  name: string;
  price : any;
  type: string;
  rules?: Array<Object>;

  image: String | boolean;
  disable_ingredient_change: boolean;
  ingredients: Array<Ingredient>;
  prices: Array<Object>;
  variations: Array<Object>;
  addedIngredients?: Array<Ingredient>;
  removedIngredients?: Array<Ingredient>
  payload?: ProductPayload
}



// WEBPACK FOOTER //
// ./src/app/classes/product_special.ts